const today = new Date();
export const screenDate = {
  zh: `${new Intl.DateTimeFormat('zh-CN', { weekday: 'long' }).format(today)} · ${new Intl.DateTimeFormat('zh-CN', { month: 'long', day: 'numeric' }).format(today)}`,
  en: new Intl.DateTimeFormat('en-US', { weekday: 'long', month: 'long', day: 'numeric' })
    .format(today)
    .toUpperCase(),
  weekday: new Intl.DateTimeFormat('en-US', { weekday: 'long' }).format(today),
  day: today.getDate(),
};
